import { mapActions, mapGetters } from 'vuex'
import checkErrors from '@javascript/mixins/checkErrors'
import {
  removeLocalStorage,
  redirectTo,
} from '@javascript/utils/helper-methods'
import {
  RESTORATION_RESETOPTION,
  REGISTRATION_CARD,
} from '@javascript/config/routes'
export default {
  mixins: [checkErrors],
  inject: ['locale', 'defaultLocale', 'baseUrlWithLocale'],
  props: {
    providerId: {
      type: [String, Number],
      default: null,
    },
    breadcrumbs: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    loginData: {
      email: '',
      password: '',
    },
    loadingButton: false,
    breadcrumbsData: [],
  }),
  computed: {
    ...mapGetters({
      getFormErrors: 'authorization/getFormErrors',
    }),
  },
  methods: {
    ...mapActions({
      API_LOGIN: 'authorization/API_LOGIN',
    }),
    resetPassword() {
      this.loginData.password = ''
    },
    showFormErrors() {
      this.$refs.form.setErrors({ email: [''], password: [''] })
    },
    toggleLoadingButton(value) {
      this.loadingButton = value
    },
    async login() {
      this.toggleLoadingButton(true)
      this.hideErrorNotification()
      try {
        const { data } = await this.API_LOGIN({
          ...this.loginData,
          id: this.providerId,
        })
        removeLocalStorage('email_create')
        removeLocalStorage('email_confirmed')
        removeLocalStorage('thank_cancel')
        redirectTo(data.redirect_to)
      } catch (error) {
        if (error.response.status !== 401) {
          this.showAllErrors(error, true, 0, true)
          this.showFormErrors()
        }
      } finally {
        this.toggleLoadingButton(false)
      }
    },
    resetPasswordRouter() {
      return `${this.baseUrlWithLocale}${RESTORATION_RESETOPTION}`
    },
    registrationRouter() {
      return `${this.baseUrlWithLocale}${REGISTRATION_CARD}`
    },
  },
  created() {
    this.breadcrumbsData = JSON.parse(this.breadcrumbs)
  },
}
